import {template as tpl, viewModel as UserSearch} from "./search";
import {IObjectData} from "../../index";

export let template = tpl;

export class viewModel extends UserSearch {

    protected override onRowClick(item: IObjectData) {
        if (this.params.fnValidateRow && !this.params.fnValidateRow(item)) {
            return;
        }
        this.getItemCheckbox(item).toggle()
    }

    override showOperationsButton(): boolean {
        return false;
    }

    override showTableColumn(key: string): boolean {
        if (key == 'func') {
            return false;
        }
        return super.showTableColumn(key);
    }

}
